import React, { useEffect } from 'react';
import { useLocation } from "react-router-dom";

// Assets (Giữ nguyên các đường dẫn của bạn)
import KyquansanTourW from './image/team_tour/kyquansan_w.jpg';
import TachinhuTour from './image/team_tour/tachinhu.jpg';
import NhiucosanTour from './image/team_tour/nhiucosan.jpg';
import LungcungTour2 from './image/team_tour/lungcung_2.jpg';
import TaxuaTour from './image/team_tour/taxua.jpg';
import LaothanTour from './image/team_tour/laothan.jpg';
import TaliensonTour from './image/team_tour/talienson.jpg';
import PutalengTour from './image/team_tour/putaleng.jpg';
import SamuTour from './image/team_tour/samu.jpg';
import BackImage from './image/team_tour/back.png';

// 1. Component TourCard: Thiết kế như một "Premium Ticket"
const PremiumTourCard = ({ title, height, distance, duration, cost, participants, image, reverse = false }) => (
  <div className={`flex flex-col md:flex-row items-stretch w-full max-w-6xl my-16 gap-0 overflow-hidden rounded-[50px] bg-white shadow-[0_30px_60px_-15px_rgba(0,0,0,0.1)] transition-all hover:shadow-[0_40px_80px_-20px_rgba(0,0,0,0.15)] ${reverse ? 'md:flex-row-reverse' : ''}`}>
    
    {/* Visual Side */}
    <div className="w-full md:w-3/5 relative overflow-hidden group">
      <img 
        loading="lazy" 
        src={image} 
        alt={title} 
        className="w-full h-[400px] md:h-full object-cover transition-transform duration-1000 group-hover:scale-110" 
      />
      <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>
      <div className="absolute bottom-10 left-10 text-white">
        <span className="text-xs tracking-[0.4em] uppercase opacity-80 mb-2 block">Chinh phục đỉnh cao</span>
        <h2 className="text-5xl md:text-7xl font-black tracking-tighter uppercase leading-none">{title}</h2>
      </div>
    </div>
    
    {/* Service Side */}
    <div className="w-full md:w-2/5 p-12 md:p-16 flex flex-col justify-between bg-white relative">
      <div className="space-y-6">
        <div className="flex justify-between items-end border-b border-slate-100 pb-4">
          <span className="text-slate-400 text-xs uppercase tracking-widest">Độ cao</span>
          <span className="text-2xl font-bold text-slate-800">{height}</span>
        </div>
        <div className="flex justify-between items-end border-b border-slate-100 pb-4">
          <span className="text-slate-400 text-xs uppercase tracking-widest">Cung đường</span>
          <span className="text-xl font-medium text-slate-700">{distance}</span>
        </div>
        <p className="text-sm text-slate-500 italic leading-relaxed pt-2">
          {duration}
        </p>
      </div>

      <div className="mt-12">
        <div className="mb-6">
          <span className="text-[10px] text-sky-600 font-bold uppercase tracking-[0.3em]">Giá dịch vụ trọn gói</span>
          <p className="text-4xl font-black text-slate-900 mt-1">{cost}</p>
          <p className="text-xs text-slate-400 mt-2">Dành cho nhóm tiêu chuẩn {participants} người</p>
        </div>
        
        <button 
          onClick={() => window.open('https://www.facebook.com/leminhofhaiduong')}
          className="w-full py-5 bg-sky-600 text-white rounded-2xl font-bold uppercase tracking-widest text-xs hover:bg-slate-900 transition-all shadow-lg active:scale-95">
          Đặt chỗ ngay
        </button>
      </div>
    </div>
  </div>
);

// 2. Component giới thiệu triết lý dịch vụ
const ServicePhilosophy = () => (
  <div className="w-full max-w-4xl grid grid-cols-1 md:grid-cols-2 gap-8 my-20">
    <div className="p-10 bg-white/60 backdrop-blur-xl rounded-[40px] border border-white/80 shadow-sm">
      <h3 className="text-sky-600 font-black text-xl mb-4 uppercase tracking-tight">Sức khỏe là ưu tiên</h3>
      <p className="text-slate-600 leading-relaxed italic">
        "EASY TREK được thiết kế để bạn có thể trạng tốt nhất, trọn vẹn sức lực dành cho việc chinh phục thử thách thay vì mệt mỏi bởi hành lý."
      </p>
    </div>
    <div className="p-10 bg-slate-900 text-white rounded-[40px] shadow-2xl">
      <h3 className="text-orange-400 font-black text-xl mb-4 uppercase tracking-tight">Riêng tư là trên hết</h3>
      <p className="text-slate-300 leading-relaxed italic">
        Tận hưởng giấc ngủ ngon tại homestay, di chuyển oto riêng tư, xe ôm xuyên bản và có đội ngũ porter hỗ trợ tối đa suốt hành trình.
      </p>
    </div>
  </div>
);

export default function HotTourTeam() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);

  return (
    <div className="relative min-h-screen font-sans bg-[#F8F9FA] antialiased"
      style={{ backgroundImage: `url(${BackImage})`, backgroundAttachment: 'fixed', 
        backgroundSize: 'cover' }}>
      
      <div className="absolute inset-0 bg-slate-900/40 backdrop-blur-[2px] z-0"></div>

      <div className="relative z-10 flex flex-col items-center w-full px-6 md:px-12 py-20">
        
        {/* Header Section phong cách Resort Luxury */}
        <header className="text-center mb-16 mt-16">
          <span className="text-sky-400 font-black font-bold tracking-[0.5em] uppercase text-xs mb-4 block">The Experience</span>
          <h1 className="text-7xl md:text-9xl font-black text-white mb-4 tracking-tighter uppercase leading-none drop-shadow-2xl">
            EASY <span className="text-sky-400 italic font-serif">TREK</span>
          </h1>
          <p className="text-lg md:text-2xl text-sky-400 max-w-2xl mx-auto font-light italic leading-relaxed">
            "Ngàn thước lên cao, ngàn thước xuống."
          </p>
        </header>

        <ServicePhilosophy />

        {/* Danh sách Tour */}
        <PremiumTourCard
        title="TÀ CHÌ NHÙ"
        height="2979m"
        distance="26KM"
        duration="18h tối thứ sáu đến 23h tối chủ nhật"
        cost="4.500.000 VNĐ/Người"
        participants="10-20"
        image={TachinhuTour}
      />

      <PremiumTourCard
        title="NHÌU CỒ SAN"
        height="2965m"
        distance="28KM"
        duration="18h tối thứ sáu đến 23h tối chủ nhật"
        cost="4.500.000 VNĐ/Người"
        participants="10-20"
        image={NhiucosanTour}
        reverse
      />

      <PremiumTourCard
        title="KỲ QUAN SAN"
        height="3046m"
        distance="34KM"
        duration="18h tối thứ năm đến 23h tối chủ nhật"
        cost="5.500.000 VNĐ/Người"
        participants="10-20"
        image={KyquansanTourW}
      />

      <PremiumTourCard
        title="LÙNG CÚNG"
        height="2913m"
        distance="26KM"
        duration="18h tối thứ sáu đến 23h tối chủ nhật"
        cost="4.500.000 VNĐ/Người"
        participants="10-20"
        image={LungcungTour2}
        reverse
      />

      <PremiumTourCard
        title="LẢO THẨN"
        height="2860m"
        distance="24KM"
        duration="18h tối thứ sáu đến 23h tối chủ nhật"
        cost="4.500.000 VNĐ/Người"
        participants="10-20"
        image={LaothanTour}
      />

      <PremiumTourCard
        title="TÀ XÙA"
        height="2865m"
        distance="26KM"
        duration="18h tối thứ sáu đến 23h tối chủ nhật"
        cost="4.500.000 VNĐ/Người"
        participants="10-20"
        image={TaxuaTour}
        reverse
      />

      <PremiumTourCard
        title="TẢ LIÊN SƠN"
        height="2996m"
        distance="28KM"
        duration="18h tối thứ sáu đến 23h tối chủ nhật"
        cost="5.500.000 VNĐ/Người"
        participants="10-20"
        image={TaliensonTour}
      />

      <PremiumTourCard
        title="PUTALENG"
        height="3083m"
        distance="36KM"
        duration="18h tối thứ năm đến 23h tối chủ nhật"
        cost="5.500.000 VNĐ/Người"
        participants="10-20"
        image={PutalengTour}
        reverse
      />

      <PremiumTourCard
        title="SAMU"
        height="2856m"
        distance="28KM"
        duration="18h tối thứ sáu đến 23h tối chủ nhật"
        cost="4.500.000 VNĐ/Người"
        participants="10-20"
        image={SamuTour}
      />
        

        {/* Footer */}
        <footer className="mt-32 mb-10 text-center">
            <div className="h-[1px] w-20 bg-slate-200 mx-auto mb-8"></div>
            <p className="text-slate-400 text-xs tracking-[0.5em] uppercase">
                © {new Date().getFullYear()} Keep Going Trek — The Art of Service
            </p>
        </footer>
      </div>
    </div>
  );
}